//images
import OzonLogo from '../images/marketplace-ozon.svg';
import WbLogo from '../images/marketplace-wb.svg';
import YandexLogo from '../images/marketplace-yandex.svg';

export default function Marketplaces() {
    return (
        <div className="marketplace-links">
            <div className="marketplace-links__title">we are on marketplaces</div>
            <ul className="marketplace-links__list">
                <li className="marketplace-link">
                    <a href="https://www.ozon.ru/seller/iek-group-ofitsialnyy-magazin-proizvoditelya-1412513/products/?miniapp=seller_1412513">
                        <img src={OzonLogo} alt=""/>
                    </a>
                </li>
                <li className="marketplace-link">
                    <a href="https://www.wildberries.ru/seller/3945038">
                        <img src={WbLogo} alt=""/>
                    </a>
                </li>
                <li className="marketplace-link">
                    <a href="https://market.yandex.ru/cc/7po4eU">
                        <img src={YandexLogo} alt=""/>
                    </a>
                </li>
            </ul>
        </div>
    );
}